import useUserDetails from "./user-details.hook";
import { DATE_FORMAT } from "../constants/app.constants";

const useDateFormat = () => {
  const { userDetails } = useUserDetails();
  const currentUserDateFormat = userDetails?.RegionalInfo?.ShortDateFormat;

  return currentUserDateFormat 
      ? currentUserDateFormat?.toUpperCase()
      : DATE_FORMAT;
};

export default useDateFormat;
